export default __webpack_public_path__ + "static/media/NotoSansJP-Regular.b2753ebb.ttf";